(() => {
  document.addEventListener('mouseenter', (e) => {
    if (!(e.target instanceof Element)) return;
    const card = e.target.closest('.nopa-card');
    if (!card) return;
    const video = card.querySelector('.nopa-card__media--hover video');
    if (video) { video.play().catch(() => {}); }
  }, true);
  document.addEventListener('mouseleave', (e) => {
    if (!(e.target instanceof Element)) return;
    const card = e.target.closest('.nopa-card');
    if (!card) return;
    const video = card.querySelector('.nopa-card__media--hover video');
    if (video) { video.pause(); video.currentTime = 0; }
  }, true);

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-nopa-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) { window.location.href = btn.dataset.url; return; }
    btn.classList.add('is-loading');
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        const cartRes = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble');
        const sections = await cartRes.json();
        drawer.renderContents({ sections });
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    } catch (err) {
      window.location.href = btn.dataset.url;
    } finally {
      btn.classList.remove('is-loading');
    }
  });
})();
